var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
import { initFormValidation, showSubmitError, checkControlPhrase } from '../components/form-validation';
const initBlock = () => {
    const submitButton = document.querySelector('.js-form-submit');
    submitButton &&
        submitButton.addEventListener('click', (e) => __awaiter(void 0, void 0, void 0, function* () {
            const form = document.querySelector('.js-form');
            const loader = document.querySelector('.js-form-loader');
            loader && loader.classList.add('show');
            const formIsValid = initFormValidation(form);
            if (formIsValid && checkControlPhrase()) {
                form.submit();
            }
            else {
                loader && loader.classList.remove('show');
                showSubmitError('Please fill in all fields correctly!');
                if (!checkControlPhrase()) {
                    const controlError = document.querySelector('.js-wrong-control');
                    controlError && controlError.classList.add('show');
                }
            }
        }));
};
document.addEventListener('DOMContentLoaded', initBlock, false);
if (window.acf) {
    (_a = window.acf) === null || _a === void 0 ? void 0 : _a.addAction('render_block_preview', initBlock);
}
